import { CountryManagementListItem, CountryManagementUpdateDto } from 'types/country-management';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APICountryManagementSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['CountryManagement'] }).injectEndpoints({
    endpoints: (builder) => ({
        getCountryManagementWithFilters: accumulatedQueryWithFilters<CountryManagementListItem>(
            builder,
            '/v1/country-management',
            {
                sort: 'code,asc',
                providesTags: ['CountryManagement'],
            }
        ),
        updateCountryManagement: builder.mutation<
            CountryManagementListItem,
            { countryCode: string } & CountryManagementUpdateDto
        >({
            query: ({ countryCode, ...body }) => ({
                url: `/v1/country-management/${countryCode}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['CountryManagement'],
        }),
    }),
    overrideExisting: false,
});

export const { useLazyGetCountryManagementWithFiltersQuery, useUpdateCountryManagementMutation } =
    APICountryManagementSlice;
